import { render, staticRenderFns } from "./IssuerFeeUpdateModal.vue?vue&type=template&id=67ec0ed8&"
import script from "./IssuerFeeUpdateModal.vue?vue&type=script&lang=ts&"
export * from "./IssuerFeeUpdateModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./IssuerFeeUpdateModal.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(component)

export default component.exports